import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Update the lang attribute of the <html> element
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div>
      <select onChange={(e) => changeLanguage(e.target.value)}>
        <option value="fr">Français</option>
        <option value="en">English</option>
      </select>
    </div>
  );
}

export default LanguageSelector;
